import { Component, Input } from '@angular/core';

@Component({
  selector: 'ds-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss']
})
export class NoDataComponent {
  @Input() title = 'MODULES.COMMON.NO_RESULTS';
  @Input() description = 'MODULES.COMMON.NO_RESULTS_DESCRIPTION';

}
